interface TentIconOptions {
    cssClasses?: string
}

export function IconTent(props: TentIconOptions) {
    return (
        <svg id="be5f5c35-3a09-4372-bac0-0c95124714c7" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13.97"  className={props?.cssClasses}>
            <path className="e51072ec-6885-4c5c-9dd2-e587442a1fc0" d="M15.8,13.4,9.2,4.7l1.5-2.1a1.08,1.08,0,0,0-.2-1.4,1,1,0,0,0-1.3.2L8,3,6.8,1.4a1.08,1.08,0,0,0-1.4-.2,1.08,1.08,0,0,0-.2,1.4L6.7,4.7.2,13.4A1,1,0,0,0,1,15H5l3-4,3,4h4A1,1,0,0,0,15.8,13.4Z" transform="translate(0 -1.03)"/>
        </svg>
    )
}
